import { pathOr } from 'ramda';
import hyperid from 'hyperid';
import { createSelector } from 'reselect';
import {
  MARK_AS_SHOWN,
  PERSONAL_EVENTS,
  SET_PERSONAL_INFO,
  USER_IS_READY_FOR_NEW_PERSONAL_DATA,
} from '../../../../constants/centrifugo';
import { PROJECTS } from '../../../../../constants/centrifugo';
import type { RootState } from '../../../../store';

export interface PersonalChannelState {
  data: Array<{
    wasShown: boolean;
    id: string;
    isShown: boolean;
    type: string;
  }>;
  isReady: boolean;
}

const initialState: PersonalChannelState = {
  data: [],
  isReady: false,
};

export const personalChannelReducer = (
  state = initialState,
  action: { type: string; payload: any }
): PersonalChannelState => {
  switch (action.type) {
    case SET_PERSONAL_INFO: {
      return {
        ...state,
        data: [
          ...state?.data,
          {
            id: hyperid().uuid,
            ...action?.payload,
            isShown: false,
          },
        ],
        isReady: false,
      };
    }

    case MARK_AS_SHOWN: {
      const item = state?.data?.find((i) => i.id === action?.payload);
      if (item) {
        item.wasShown = true;
        return {
          ...state,
          data: [...state.data],
        };
      }
      return state;
    }

    case USER_IS_READY_FOR_NEW_PERSONAL_DATA:
      return {
        ...state,
        isReady: action?.payload,
      };
    default: {
      return state;
    }
  }
};

const eventsSelector = (state: RootState) =>
  pathOr(
    initialState?.data,
    ['domain', 'centrifugo', PROJECTS.PERSONAL, 'data'],
    state
  );

export const isUserReadyToGetNewEvent = (state: RootState) =>
  pathOr(
    initialState?.isReady,
    ['domain', 'centrifugo', PROJECTS.PERSONAL, 'isReady'],
    state
  );
const insufficientEventsSelector = createSelector(eventsSelector, (state) =>
  state?.filter((item) => item?.type === PERSONAL_EVENTS.INSUFFICIENT_BALANCE)
);

export const notShownInsufficientEventSelector = createSelector(
  insufficientEventsSelector,
  (state) => state?.find((item) => !item?.wasShown)
);
